
            "use strict";

            // Do no edit this file - it is generated automatically during publish 

            // This file is used to 'fake' submodules, so that we 
            // can import '@amzn/atoz-<pkgName>/Expander' instead of '@amzn/atoz-<pkgName>/dist/Expander'

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            var _submodule = require("./dist/Expander");

            Object.keys(_submodule).forEach(function (key) {
            if (key === "default" || key === "__esModule") return;
            Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: function get() {
                        return _submodule[key];
                    }
                });
            });
        